module.exports = __webpack_public_path__ + "static/media/firebase-cloud-function.85884fa2.svg";